export default "//file.bilionpass.com/japandx-web/0.0.1/static/scan.6877b199-b51d2e.svg";